var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Lightbox',{attrs:{"visible":_vm.$props.toggler,"imgs":_vm.$props.images,"index":_vm.$props.index,"moveDisabled":"","rotateDisabled":""},on:{"hide":_vm.closeViewer,"on-index-change":_vm.recreateDownloadButton}})}
var staticRenderFns = []

export { render, staticRenderFns }